module.exports = __webpack_public_path__ + "img/product-placeholder-36.912196e.png";